import { Package, Truck, FileText, Receipt, BarChart3, Shield } from 'lucide-react';

const features = [
  {
    icon: Package,
    title: 'Load Management',
    description:
      'Create, assign, and track loads from pickup to delivery with real-time status updates.',
  },
  {
    icon: Truck,
    title: 'Driver & Vehicle Tracking',
    description:
      'Manage your entire fleet. Track CDL expiry, vehicle maintenance, and driver availability.',
  },
  {
    icon: FileText,
    title: 'Document Vault',
    description:
      'Store BOLs, insurance certs, and delivery photos. Search and access from anywhere.',
  },
  {
    icon: Receipt,
    title: 'Billing & Invoicing',
    description:
      'Generate invoices, track payments, and manage payout requests all in one place.',
  },
  {
    icon: BarChart3,
    title: 'Live Dashboard',
    description:
      'Real-time overview of loads, revenue, and fleet status with interactive charts.',
  },
  {
    icon: Shield,
    title: 'Audit Trail',
    description:
      'Complete history of every action. Stay compliant with built-in activity logging.',
  },
];

function FeatureCard({ icon: Icon, title, description }) {
  return (
    <div
      className="
        bg-white border border-gray-200 rounded-2xl p-8
        hover:shadow-xl hover:border-blue-200 hover:-translate-y-1
        transition-all duration-200
      "
    >
      <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-blue-500 to-cyan-400 flex items-center justify-center mb-5">
        <Icon className="w-6 h-6 text-white" strokeWidth={1.75} />
      </div>
      <h3 className="text-xl font-semibold text-gray-900 mb-2">{title}</h3>
      <p className="text-gray-500 text-sm leading-relaxed">{description}</p>
    </div>
  );
}

export default function FeaturesGrid() {
  return (
    <section id="features" className="bg-white py-24">
      <div className="max-w-7xl mx-auto px-6">
        {/* Eyebrow */}
        <div className="flex flex-col items-center text-center mb-14">
          <div className="flex items-center gap-3 mb-4">
            <div className="h-px w-8 bg-gradient-to-r from-transparent to-blue-500" />
            <span className="text-sm font-semibold text-blue-600 uppercase tracking-widest">
              Features
            </span>
            <div className="h-px w-8 bg-gradient-to-l from-transparent to-blue-500" />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Everything Your Fleet Needs
          </h2>
          <p className="text-gray-500 text-lg max-w-xl">
            From dispatch to delivery, LoadApp covers every mile.
          </p>
        </div>

        {/* Feature cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature) => (
            <FeatureCard key={feature.title} {...feature} />
          ))}
        </div>
      </div>
    </section>
  );
}
